const mainContent = document.querySelector('#MainContent[data-template="index"]');

if (mainContent) {
  const sections = Array.from(mainContent.querySelectorAll(':scope > .shopify-section'));
  const shouldReduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isDesignMode = document.documentElement.classList.contains('shopify-design-mode');

  const revealSection = (section) => {
    section.classList.add('home-scroll-reveal-ready', 'is-visible');
  };

  if (sections.length) {
    revealSection(sections[0]);

    sections.slice(1).forEach((section, index) => {
      section.classList.add('home-scroll-reveal-ready');
      section.style.setProperty('--home-reveal-delay', `${Math.min(index, 4) * 70}ms`);
    });
  }

  if (!shouldReduceMotion && !isDesignMode && sections.length > 1) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.14,
        rootMargin: '0px 0px -10% 0px',
      }
    );

    sections.slice(1).forEach((section) => observer.observe(section));
  } else {
    sections.slice(1).forEach(revealSection);
  }
}
